<template>
  <div class="PaidMemberRemoval1">
    <section-header heading="2" ja="有料会員登録の解約" />
    <div class="description">有料会員の解約を行います</div>
    <template>
      <div class="description">有料会員を解約しますがよろしいでしょうか？</div>
      <normal-btn @click="onRemoval">有料会員の解約をする</normal-btn>
    </template>
    <sub-btn @click="onHome">ホームへ戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from "../components/NormalBtn"
import SubBtn from "../components/SubBtn"
import Protobuf from '../mixins/protobuf'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "PaidMemberRemoval2",
  components: {
    SectionHeader,
    NormalBtn,
    SubBtn
  },
  mixins: [Protobuf],
  data() {
    return {
      expire: null,
      paymentType: null,
    }
  },
  computed: {
    isApp() {
      return this.paymentType === pb.PlayerInfoResp.PaymentType.APPLE || this.paymentType === pb.PlayerInfoResp.PaymentType.GOOGLE
    }
  },
  methods: {
    onHome() {
      this.$router.push('/')
    },
    onAboutAppsubscription() {
        this.$router.push('/AboutAppsubscription')
    },
    onRemoval() {
      const cmdNo = pb.BuyMembershipUnsubscribeReq.CommandNo.COMMAND_NO
      const message = pb.BuyMembershipUnsubscribeReq.create()
      const encoded = pb.BuyMembershipUnsubscribeReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.BuyMembershipUnsubscribeResp.Status.SUCCESS) {
            this.$store.dispatch('saveMembershipGrade', decoded.membershipGrade)
            this.$router.push('/paidMemberRemovalFinish')
          } else {
            this.$_error('Error', { title: '有料会員解約', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: '有料会員解約', statusCode: 100 })
        })
    },
    toPaymentTypeString(type) {
      switch (type) {
        case pb.PlayerInfoResp.PaymentType.APPLE:
          return 'App Store'
        case pb.PlayerInfoResp.PaymentType.GOOGLE:
          return 'Google Play'
        case pb.PlayerInfoResp.PaymentType.WEB_DOCOMO:
          return 'd払い'
        case pb.PlayerInfoResp.PaymentType.WEB_AU:
          return 'auかんたん決済(au / UQ mobile)/au PAY'
        case pb.PlayerInfoResp.PaymentType.WEB_SOFTBANK:
          return 'ソフトバンク・ワイモバイルまとめて支払い'
        case pb.PlayerInfoResp.PaymentType.WEB_AIME:
        case pb.PlayerInfoResp.PaymentType.WEB_CARD:
          return 'クレジットカード'
        default:
          return ''
      }
    },
  },
  mounted() {
    const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
    const message = pb.PlayerInfoReq.create()
    const encoded = pb.PlayerInfoReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        let expireTime = new Date(decoded.memberExpireDate * 1000);
        let nowTime = new Date(Date.now());
        nowTime.setMonth(nowTime.getMonth() + 13);
        this.expire = (expireTime < nowTime);
        this.paymentType = decoded.paymentType;
      })
      .catch(() => {
        this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
      })
    }

}
</script>

<style lang="scss" scoped>
.description {
  color: #373737;
  font-size: 12px;
  margin: 30px 30px 0;
}
.caution {
  color: #EF2562;
  font-size: 12px;
  margin: 30px 30px 0;
  a { color: #5F96C9; }
}
</style>
